import React from 'react';
import { Provider, useSelector } from 'react-redux';
import { store, persistor } from './app/store';
import { PersistGate } from 'redux-persist/integration/react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Header from './components/header';
import Loader from './components/loader';
import LoginPage from './pages/login';
import PrivateRoute from './components/private-routes';
import DashboardPage from './pages/dashboard';
import LandingPage from './pages/landing-page';
import CursorTrail from './components/cursor-trail';

function MainApp() {
  const { isAuthenticated } = useSelector((state) => state.user);

  return (
    <div className='font-sans min-h-screen bg-darkBg text-white relative overflow-hidden selection:bg-white selection:text-black'>


      <Header />
      <Loader />
      <CursorTrail />

      <main className='pt-20 relative z-10'>
        <Routes>
          <Route
            path='/login'
            element={
              isAuthenticated ? (
                <Navigate to='/dashboard' replace />
              ) : (
                <LoginPage />
              )
            }
          />

          <Route element={<PrivateRoute />}>
            <Route path='/dashboard' element={<DashboardPage />} />
          </Route>

          <Route path='/' element={<LandingPage />} />
          <Route path='*' element={<Navigate to='/' replace />} />
        </Routes>
      </main>
    </div>
  );
}

export default function App() {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <BrowserRouter>
          <MainApp />
        </BrowserRouter>
      </PersistGate>
    </Provider>
  );
}
